//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageViewer from '../Images/ImageViewer.vue'

export default {
  components: {
    ImageViewer: ImageViewer
  },
  props: {
    sectionData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    imageUrl: {
      type: String,
      default: null
    },
    width: {
      type: Number,
      default: 140
    },
    height: {
      type: Number,
      default: 140
    },
    notShowOnClick: {
      type: Boolean,
      default: false
    },
    objectCardUrl: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    backgroundImageStyle: function () {
      if (this.imageUrl) {
        return `background-image: url("${this.imageUrl}"); background-size: cover; background-position: 50%;`
      }
      return ''
    }
  },
  methods: {
    openFilePickDialog: function () {
      document.getElementById('imageFilePicker').click()
    },
    uploadFile (e) {
      this.$emit('upload', e)
    },
    onClickImage: function (event) {
      if (!this.notShowOnClick) {
        this.onShowImage()
      }
    },
    onShowImage: function (e) {
      if (e) {
        e.preventDefault()
      }
      if (this.imageUrl) {
        this.$refs.imagesViewer.show([{
          url: this.imageUrl
        }], 0)
      }
    }
  }
}

